import axios from 'axios';
import { apiRoutes } from '../../apiRoutes';
import { authHeader } from '../../global';

import Vue from 'vue'


const getDefaultStateForEmployee = () => {
  return {
    salesperson_list: []
  }
}

// state
const state = getDefaultStateForEmployee()

// getters
const getters = {

}

// mutations
const mutations = {
    RESET_STATE_FOR_EMPLOYEE (state) {
      Object.assign(state, getDefaultStateForEmployee())
    },
    FETCH_ALL_SALES_PERSON(state, data){
      state.salesperson_list = data
    },
    FETCH_ALL_SALES_PERSON_FOR_CUSTOMER(state, data) {
      let list = []
      data.forEach(function (element) {
          let item = {linked_contact_id: element.id, name:element.name}
          list.push(item)
      });
      state.salesperson_list = list

    }
}

// actions
const actions = {
    resetState({ commit }, payload) {
      commit("RESET_STATE_FOR_EMPLOYEE")
    },
   fetchAllSalesPersonForCustomer({commit}, data) {
    return axios.post(apiRoutes['LIST_SALE_PERSOPNS'], data, authHeader())
    .then(response => {
      if(response.data.code == 1)
      {
        commit('FETCH_ALL_SALES_PERSON_FOR_CUSTOMER', response.data.data)
      } 
      else 
      {
        commit('FETCH_ALL_SALES_PERSON_FOR_CUSTOMER', [])
      }
    })
    .catch(error => {
      if (error.response) {
        console.log(error.response)
          Vue.notify({
              group: 'notify',
              type: 'error',
              text: error.response.data.msg,
              max: 5, duration: 5000, speed: 300
          })
      } else {
          console.log("Problem Querying Data!", error);
      }
  });
   },
    fetchAllSalesPerson({ commit }, data) {
        return axios.post(apiRoutes['LIST_SALE_PERSOPNS'], data, authHeader())
            .then(response => {
              if(response.data.code == 1)
              {
                commit('FETCH_ALL_SALES_PERSON', response.data.data)
              } 
              else 
              {
                commit('FETCH_ALL_SALES_PERSON', [])
              }
            })
            .catch(error => {
              if (error.response) {
                console.log(error.response)
                  Vue.notify({
                      group: 'notify',
                      type: 'error',
                      text: error.response.data.msg,
                      max: 5, duration: 5000, speed: 300
                  })
              } else {
                  console.log("Problem Querying Data!", error);
              }
          });
    },

}

export {
    state,
    getters,
    actions,
    mutations
}
